<ion-header>
  <div
    class="flex-space-between"
    style="
      padding: 8px;
      border-bottom: 1px solid var(--ion-subtle-border-color);
    "
  >
    <div class="button-container flexed-align-center">
      <div class="flexed-align-center">
        <ion-searchbar
          mode="ios"
          placeholder="Search topics..."
          showCancelButton="never"
          class="rounded-search-bar"
          [debounce]="300"
          (ionChange)="handleSearch($event)"
        ></ion-searchbar>
      </div>
    </div>
    <div style="display: flex">
      <ion-button (click)="openCreateTopicModal()">
        <ion-icon name="radio-outline"></ion-icon>
        <span class="text-with-left-icon hidden-sm"> Create topic </span>
      </ion-button>
    </div>
  </div>
</ion-header>
<ion-content>
  <div class="constrained-content">
    <ion-card class="outline-card">
      <ngx-datatable
        class="material datatable-row-borders"
        [columnMode]="ColumnMode.force"
        [limit]="limit"
        [headerHeight]="44"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        style="height: unset"
        paginated
        [dataSource]="topicsDataSource"
        [loadingIndicator]="isLoading"
      >
        <ngx-datatable-column name="Name" [minWidth]="225">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a (click)="editTopic(row)">{{ row.name }}</a>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="Updated at"
          [minWidth]="100"
          [sortable]="true"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.updatedAt | date: "MMM d yyyy h:mm a" }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name=""
          [minWidth]="100"
          [maxWidth]="100"
          [sortable]="false"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a (click)="deleteTopic(row)"> Remove </a>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card>
  </div>
</ion-content>
